<template>
    <section class="avis-redaction">
        <h3 class="avis-redaction-titre">Avis demandé</h3>
        <p class="avis-question">{{ avis.question }}</p>
        <template v-if="avis.repondu_at">
            <h3 class="avis-redaction-titre">Avis du confrère</h3>
            <p class="avis-question avis-reponse-enregistree">{{ avis.reponse }}</p>
        </template>
        <form v-else @submit.prevent="envoyer">
            <div class="avis-redaction-entete">
                <label :for="champId">Votre réponse clinique</label>
                <BoutonDictee v-if="!disabled" ref="dictee" :pour="champId" />
            </div>
            <textarea :id="champId" :value="value" :disabled="disabled" rows="4" maxlength="4000"
                class="form-control" placeholder="Rédigez ou dictez votre avis…"
                :aria-describedby="champId + '-compteur'" @input="$emit('input', $event.target.value)"></textarea>
            <div class="avis-redaction-bas">
                <small :id="champId + '-compteur'">{{ value.length }} / 4 000 caractères</small>
                <button type="submit" class="btn btn-primary" :disabled="disabled || !value.trim() || value.length > 4000">
                    {{ saving ? 'Enregistrement…' : 'Envoyer la réponse' }}
                </button>
            </div>
        </form>
    </section>
</template>
<script>
import BoutonDictee from '@/components/dictee/bouton-dictee.vue'
export default {
    name: 'AvisReponse',
    components: { BoutonDictee },
    props: {
        avis: { type: Object, required: true },
        value: { type: String, default: '' },
        champId: { type: String, required: true },
        disabled: { type: Boolean, default: false },
        saving: { type: Boolean, default: false }
    },
    methods: {
        arreterDictee() { if (this.$refs.dictee) this.$refs.dictee.arreter() },
        envoyer() {
            if (this.disabled || !this.value.trim() || this.value.length > 4000) return
            this.arreterDictee()
            this.$emit('envoyer')
        }
    }
}
</script>
<style lang="scss">
.avis-redaction {
    color: var(--ui-text, #172033);
    .avis-redaction-titre, label { font-size: 15px; font-weight: 600; margin: 0; }
    .avis-question { white-space: pre-wrap; overflow-wrap: anywhere; margin: 8px 0 18px; }
    .avis-redaction-entete { display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 10px; }
    textarea.form-control { width: 100%; border: 1px solid #aebdd4; border-radius: 12px; padding: 12px; font-size: 15px; min-height: 112px; }
    .avis-redaction-bas { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; margin-top: 10px; }
    .avis-redaction-bas small { color: var(--ui-text-muted, #526074); }
    .avis-redaction-bas .btn { border-radius: 999px; padding: 10px 20px; min-height: 44px; font-size: 14px; font-weight: 600; }
    .avis-reponse-enregistree { border-left: 3px solid #166044; padding: 12px; background: #f0f8f5; border-radius: 8px; }
}
</style>
